import type { CSSProperties } from "react";

export interface TabItem {
  value: string;
  label: string;
}

export interface TabsProps {
  items: Array<string | TabItem>;
  value?: string;
  onChange?: (value: string) => void;
  fill?: boolean;
  style?: CSSProperties;
}

/** Underline tab bar. `items` is an array of { value, label } or strings. */
export function Tabs({ items = [], value, onChange, fill = false, style }: TabsProps) {
  const norm: TabItem[] = items.map((it) => (typeof it === "string" ? { value: it, label: it } : it));
  const active = value ?? norm[0]?.value;
  return (
    <div
      style={{
        display: "flex",
        borderBottom: "1px solid var(--line-normal-neutral)",
        fontFamily: "var(--font-sans)",
        ...style,
      }}
    >
      {norm.map((it) => {
        const on = it.value === active;
        return (
          <button
            key={it.value}
            type="button"
            onClick={() => onChange?.(it.value)}
            style={{
              flex: fill ? 1 : "none",
              position: "relative",
              padding: "12px 16px",
              border: "none",
              background: "transparent",
              cursor: "pointer",
              fontSize: "var(--font-size-headline-2)",
              fontWeight: on ? 700 : 500,
              color: on ? "var(--label-normal)" : "var(--label-alternative)",
              transition: "color var(--duration-fast) var(--ease-standard)",
            }}
          >
            {it.label}
            <span
              style={{
                position: "absolute",
                left: 8,
                right: 8,
                bottom: -1,
                height: 2,
                borderRadius: 2,
                background: on ? "var(--label-normal)" : "transparent",
              }}
            />
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
